export const settingsCertificationEn = {
  issuingOrganizations: {
    addIssuingOrganization: 'Add issuing organization',
    description:
      'Organizations that issue certifications, including government agencies, professional societies, and corporations.',
    editIssuingOrganization: 'Edit {{name}}',
    form: {
      address: {
        description: 'Address of the organization.',
        label: 'Address',
      },
      email: {
        description: 'Contact email address.',
        label: 'Email',
      },
      issuerOrganizationName: {
        description: 'Name should be unique in your organization.',
        label: 'Organization Name',
        placeholder: 'Ministry of Health, Professional Association',
      },
      organizationType: {
        description: 'Select the type of organization.',
        label: 'Organization Type',
        placeholder: 'Government, Society, Corporation',
      },
      phoneNumber: {
        description: 'Contact phone number.',
        label: 'Phone Number',
      },
      remarks: {
        description: 'Additional notes or comments.',
        label: 'Remarks',
        placeholder: 'Additional information',
      },
      url: {
        description: 'Organization website URL.',
        label: 'URL',
        placeholder: 'https://example.com',
      },
    },
    searchPlaceholder: 'Filter by name...',
    showDeactivated: 'Show only deactivated',
    title: 'Issuing Organizations',
  },
  shared: {
    DeleteDialog: {
      cancelButton: 'Cancel',
      description:
        'If you use {{name}}, you cannot delete master name. This operation cannot be undone.',
      permanentlyDeleteButton: 'Permanently Delete',
      title: 'Delete {{name}}?',
    },
    DisableDialog: {
      cancelButton: 'Cancel',
      description:
        'If you deactivate {{name}}, you will not use it anymore. The data will not be deleted and can view it in past data. You can activate it again.',
      disableButton: 'Deactivate',
      title: 'Deactivate {{name}}?',
    },
    EnableDialog: {
      cancelButton: 'Cancel',
      description:
        'If you activate {{name}}, you can use it again. The previously deactivated data will be restored to active status and available for use.',
      enableButton: 'Activate',
      title: 'Activate {{name}}?',
    },
    actionsColumn: {
      deleteButton: 'Delete',
      disableButton: 'Deactivate',
      enableButton: 'Activate',
    },
    editDisplayOrder: 'Edit display order',
  },
  specialtyCategories: {
    addSpecialtyCategory: 'Add specialty category',
    description:
      'A classification that indicates the type of specialty certification, and includes different specialty categories such as medical, nursing, and pharmacy.',
    editSpecialtyCategory: 'Edit {{name}}',
    form: {
      displayOrder: {
        description: {
          forAdd:
            'If you do not input display order, default value 0 will be set.',
        },
        label: 'Display order',
        placeholder: '1',
      },
      name: {
        description: 'Name should be unique in your organization.',
        label: 'Name',
        placeholder: 'Medical, Nursing, Pharmacy',
      },
      relatedBaseCertificationNames: {
        description:
          'Select the base certifications that are related to this specialty category.',
        label: 'Related Base Certifications',
        placeholder: 'Select base certifications',
      },
    },
    searchPlaceholder: 'Filter by name...',
    showDeactivated: 'Show only deactivated',
    title: 'Specialty Categories',
  },
  specialtyCategoryLevels: {
    addSpecialtyCategoryLevel: 'Add specialty category level',
    description:
      'A classification that indicates the level of specialty certification, and includes different specialty category levels such as junior, senior, and expert.',
    editSpecialtyCategoryLevel: 'Edit {{name}}',
    form: {
      displayOrder: {
        description: {
          forAdd:
            'If you do not input display order, default value 0 will be set.',
        },
        label: 'Display order',
        placeholder: '1',
      },
      name: {
        description: 'Name should be unique in the specialty category.',
        label: 'Name',
        placeholder: 'Junior, Senior, Expert',
      },
      specialtyCategoryId: {
        description:
          'Select the specialty category that this level belongs to.',
        label: 'Specialty Category',
        placeholder: 'Medical, Nursing, Pharmacy',
      },
    },
    searchPlaceholder: 'Filter by name...',
    showDeactivated: 'Show only deactivated',
    title: 'Specialty Category Levels',
  },
};
